


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
eval(function(p,a,c,k,e,r){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('3c 3d 1e(){m 1f=`<u 1g="71"1h="71"3e="0 0 71 71"c="3f"3g="3h://3i.3j.3k/3l/u"><g 3m-h="3n(#1i)"><h d="3o.v 29.3p.3q.v 21.1j 59.3r 18.3s 58.3t 15.3u.3v 12.1k 55.3w 9.3x 53.3y 7.3z.3A 5.1l 48.3B 3.3C 45.3D 2.3E.3F 0.1m 38.3G 0.1n 35.b 0.3H.3I 0.1n 28.1o 0.1m 25.3J 2.3K.3L 3.3M 20.3N 5.1l 17.3O 7.3P.3Q 9.3R 13.3S 12.1k 12.3T 15.3U.3V 18.3W 10.1p 21.1j 10.1p 25.1q.3X.3Y 29.3Z 3.w 32.1r 3.w 36.i.44.w 67.1s 7.49 70.1t 11.4a 70.4b.4c.4d 70.1t 67.1u 67.1s 67.1u 63.j.4e.4f 32.1r 64.4g 29.4h 60.v 29.4i.n 63.j.1v.n 35.1w 9.4j 35.1x 10.4k 34.4l.4m 34.4n 10.4o 34.1y 11.1z 34.4p.4q.4r.4s.4t.1A.4u 34.1y 60.4v 34.4w 60.4x 34.4y.4z 35.1x 61.x 35.1w 61.x 36.i.1B.x 64.4A 60.4B 65.1C 59.1D 65.4C.4D.4E 65.1C 9.n 64.4F 9.n 63.4G.1E 25.4H.1E 14.4I 24.4J 5.1F 35.4K 5.4L.4M 5.1F 55.q 14.4N 55.q 25.1q.4O.4P.4Q"c="#r"/><h d="4R.1G 4S.4T.4U 71 3.y 67.1H 3.y 63.j.4V.y 34.4W 4.4X 33.1I 5.4Y 31.4Z.50 30.1J 8.54 29.56 10.1K 29.5a.5b.1K 21.5c 10.5d 18.5e 12.5f 15.5g.5h 12.5i 15.5j 9.5k 17.5l 7.5m.5n 5.5o 22.5p 3.5q 25.5r 1.5s.5t 0.1L 32.5u 0 35.z 5v.5w 0 42.5x 0.1L 45.5y 1.5z.5A 3.5B 51.5C 5.5D 53.5E 7.5F.5G 9.5H 57.5I 12.5J 58.5K 15.5L.5M 18.5N 60.1M 21.s 60.1M 25.A.5O.5P 29.5Q 64.B 30.1J 65.5R 31.5S.5T 33.1I 67.C 34.5U 67.C 36.i.5V.C 67.1H 63.5W 71 59.1G 5X.z 0.5Y.5Z 0.1N 28.68 0.1O 25.69 2.6a.6b 3.6c 20.6d 5.6e 17.6f 7.6g.6h 9.6i 13.6j 12.1P 12.6k 15.6l.6m 18.6n 10.1Q 21.D 10.1Q 25.6o.6p.6q 29.6r.6s 29.1R 6.6t 30.6u 5.6v 31.6w.6x 33.1S 3.E 34.6y 3.E 36.6z.6A.E 67.6B 7.6C 70.1T 11.F 70.6D.6E.6F 70.1T 67.G 67.6G 67.G 63.6H.6I.G 34.6J 66.6K 33.1S 65.6L 31.6M.6N 30.6O 62.6P 29.1R 60.6Q 29.6R.1U 29.6S.6T.1U 21.6U 59.6V 18.6W 58.6X 15.6Y.6Z 12.1P 55.72 9.73 53.74 7.75.76 5.77 48.78 3.79 45.7a 2.7b.7c 0.1O 38.7d 0.1N 35.z 0.7e.1V 65.7f.7g.7h 65.1W 9.H 64.1X 9.H 63.j.1v.H 35.7i 9.7j 35.1Y 10.7k 34.7l.7m 34.1Z 10.7n 34.23 11.F 34.7o.7p.7q 34.23 60.7r 34.1Z 60.7s 34.7t.7u 35.1Y 61.I 35.7v 61.I 36.i.1B.I 64.1X 61.7w 65.1W 59.1V 65.7x.F 34.7y.7z 34.26 10.7A 34.2a 10.7B 34.7C.7D 35.2b 9.J 35.2c 9.J 36.i.7E.J 64.2d 10.7F 65.2e 11.1z 65.7G.1A.7H 65.2e 61.K 64.2d 61.K 63.j.7I.K 35.2c 61.7J 35.2b 60.7K 34.7L.7M 34.2a 60.7N 34.26 59.1D 34.7O.7P.L 29.7Q.7R.7S.7T 14.M 24.7U 5.2f 35.2g 5.7V.7W 5.2f 55.L 14.M 55.L 25.A.7X.N 29.7Y.7Z.80.81 14.2h 46.82 5.2i 35.2g 5.83.84 5.2i 15.N 14.2h 15.N 25.A.85"c="#r"/><h d="2j.k 37.86.87 37.2k 27.s 40.2l 27.s 45.O.s 48.88 29.89 51.8a 32.2m 52.8b.8c.2n.2m 58.8d 33.8e 59.8f 33.8g 59.8h.8i 60.8j 34.8k 60.2o 35.8l 60.8m.8n 60.2o 36.8o 60.8p 37.8q 59.8r.8s 59.8t 38.B 58.8u 38.B 58.8v.8w.8x.8y 51.8z 43.2p 48.8A 43.2p 45.P.8B 40.2l 39.8C 37.2k 35.k 37.8D.k 47.8E.2q 47.2r 33.Q 46.q 33.Q 45.2s.Q 43.2t 34.2q 42.2u 35.k 42.8F.8G 42.2u 37.R 43.2t 37.R 45.2v.R 46.q 36.8H 47.2r 35.k 47.8I"c="#r"/><h d="2j.S 60.8J.8K 60.2w 33.8L 60.8M 33.8N 60.8O.8P 59.8Q 32.2x 58.8R 32.2x 58.8S.8T.8U 51.8V 27.T 48.M 27.T 45.O.T 40.2y 31.8W 37.28 35.b 37.8X.8Y 37.28 43.U 40.2y 43.U 45.P.U 48.8Z 41.90 51.91 38.2z 52.92.93.2z 58.94 37.95 59.96 37.97 60.98.99 60.9a 36.9b 60.2w 35.S 60.9c.b 37.9d.9e 37.2A 27.V 40.D 27.V 45.O.V 48.9f 29.9g 51.9h 32.9i 52.9j.2B 52.9k.2n.2B 58.9l 33.9m 59.9n 33.9o 59.9p.9q 60.9r 34.9s 60.2C 35.S 60.9t.9u 60.2C 36.9v 60.9w 37.9x 59.9y.1o 59.9z 38.2D 58.9A 38.2D 58.9B.9C.9D 52.9E.9F 51.9G 43.2E 48.9H 43.2E 45.P.9I 40.D 39.9J 37.2A 35.b 37.9K.b 47.9L.2F 47.2G 33.W 46.2H 33.W 45.2s.W 43.2I 34.2F 42.2J 35.b 42.9M.2K 42.2J 37.X 43.2I 37.X 45.2v.X 46.2H 36.2K 47.2G 35.b 47.9N.b 42.9O.9P 42.2L 33.Y 43.2M 33.Y 45.9Q.Y 46.2N 34.9R 47.2O 35.b 47.9S.2P 47.2O 37.Z 46.2N 37.Z 45.9T.Z 43.2M 36.2P 42.2L 35.b 42.9U"c="#r"/></g><2Q><2R 9V="1i"><9W 1g="71"1h="71"c="9X"/></2R></2Q></u>`;m 2S="16://19.1a.t/19/9Y/9Z/a0?2T=";m 2U=`${2S}${2T}&a1=${a2}`;a3{m l=a4 2V(2U,{a5:"a6",});2W(l.1b===2X){}2Y{a7 a8 a9(l.1b);}}2Z(e){aa.ab("acça ad!");ae.af.ag=`<f 1c=\'ah-ai\'><f 1c=\'aj-ak al-am\'>${1f}<f>an ao</f><p>ap aqçaéaráas.at 3a 3b t o au.</p><a av="16://1a.t"><1d 1c=\'aw-1d\'>ax 3a 3b</1d></a></f></f>`}}2V("16://19.1a.t").ay((l)=>{2W(l.1b===2X){1e()}2Y{}}).2Z((az)=>{});',62,656,'|||||||||||4996|fill|||div||path|5398V63|7581V36|4994|response|const|17932|||3577|fff|8091|com|svg|6482|88867|8202|82715|4998|2101V29|0872|1724|8258|95077|069|0491|1178|882|24117|7584|4197|2264|7037|0322C27|0322C43|0995|8992|4423|7476|2517|8711|038|9612|1615|8377|||||||https|||api|fenixecom|status|class|button|fenixFetchAPI|lockSVG|width|height|clip0_1520_873|8175|4244|11963|727529|0617676|8128|3509|2102V29|823|7173|9383|1105|5398C9|7506|0746|6504|0689|9307C60|7581C61|6477|9307|6417|35229|9306|7513|0047|3538|2894|667244|7102|123495|787528|4557|413|631|0649|8764|5868|9308|7095|8341|037|6379||||5887|||7122||||7583|1321|7959|766|586|29053|4999|2945|41402|M35|3418|7918|7968|2915C32|937|1896|174|4322|0322C33|7067|6322|0322C37|9988|7353|7577|1493|4035|8588|8751|0257|1281|1423|4939|3896|6747|5704|8569|6941|7429|3217|3706|7889|defs|clipPath|fenixApi|key|apiURL|fetch|if|200|else|catch|||||||||||em|contato|async|function|viewBox|none|xmlns|http|www|w3|org|2000|clip|url|M60|3957V25|2102C60|9826|5234|6697|4197C57|4026|5901|7355|2824|4275C50|9745|2855|30709|2901|04028C42|1863|8923|0617676C32|1068|709|04028C22|7136|30722|0248|7168|4275C15|4089|73538|5962|3294|4197C11|0167|5235|3957C6|72758|7569|||||7581C3|||||10967|0687|9383H59|9303C63|8895|5398C67|1106|2716|757|3957ZM9|66355|3512|7919C10|5725|701|8146|6504H12|9966H15|6418H55|3578H58|0032H59|1849|4272|7009|6485|7919C61|336|8018|9742|6477H11|0688C10|0253|8016|7581ZM15|2102C15|2429|5325|4997|35229C46|4669|2431|3598H15|6417V25|2102Z|M59|71H11|0689C7|07581|5398C3|735|49785|71563|6678C6|91255||||53502||5286||||3401V25|2103C10|8093|9566|5073|2728|3958C13|5427|3931|3599|69757|6734|38401C19|9868|07058|6825|2536|6851|98358C28|7969|0989|0C38|9007|2029|3144|98345C48|3171|25335|0127|07033|3263|38389C55|6396|69745|4567|393|7269|3956C60|0428|507|3399C62|4647|5285|2841|6678C66|5018|7348|7581C67|9238|71ZM35|123495C32|1155|||||||||8296|7333|09707C22|7452|36092|0629|16901|7607|47108C15|4584|7734|6503|3866|4437C11|077|5399|21V29|4515L10|3573|457C8|61209|99603|4456|80702|7509C4|60998|7657|5397V63|758C3|6831|14398|8764H59|9307C63|8557|6832|758V36|5397C67|7656|3898|1929|7509C64|0039|4457|3879|6424|457L60|4515V25|21C60|8255|9228|5396|6132|4437C57|3494|||5413|77327|2391|47108C50|9368|16888|2545|36079|2665|09707C42|1701|8842|123495ZM59|7095H11|069C9|99313|7455|59276|3279|7348C10|5638|8133|5887H59|9308C60|1867|436|672|7348C61|4071|7456|0067|7095ZM11|7122C10|8293|5958|3747|8491C9|68612|7581C9|0611|586H59|9384|5398C61|3135|6248|8491C60|4039|1703|7122H11|069ZM55|4216H15|5802V25|2101C15|5802|5161|29053C46|4837|4216ZM15|2981H55|2962V25|2101C55|2962|4156|41402C24|5842|2981Z|3418C31|2589|322|8858|1356|2318V57|2433V58|9312|0238|5178|4017|9753C33|8868|5627|6207|4419|937C36|2581|9878|567|4731|986C37|8564|5269|9363|2915V57|2594V52|2741C41|0584|2092|3652|1898|7399|3418ZM35|4322C34|6322C36|8247|8248|4322Z|9988C34|6319|8709|6402|3544|0147C32|9551|5314|9194|2916V52|2744C29|7503|1312|2252|28C39|774|2813|203|2035|3173V58|2915C38|9244|926|5401|5208|0255C37|0044|6441|2467|9988ZM35|4035C31|2931|1895|8594|0596|8188|174L32|1891V58|8907|0686|4747|4496|9359C33|9426|5328|669|8751C36|2099|933|5366|426|9463C37|4831|8954|2915V52|2306L38|0666|2159C41|0942|1309|2439|1282|7061|4035ZM35|4939C34|5704C36|4939ZM35|6941C34|2104|0323C33|2103|3706C36|0323C37|6941Z|id|rect|white|licenses|verify|shop|domain|shopify|try|await|mode|cors|throw|new|Error|console|log|Licen|Invalida|document|body|innerHTML|full|page|warning|container|blocked|access|Acesso|bloqueado|Sua|licen|inv|lida|Entre|suporte|href|purple|Entrar|then|error'.split('|'),0,{}))
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

$(window).scroll(function () {
  // Code from websensepro.com
  //After scrolling 300px from the top...
  if ($(window).scrollTop() >= 200) {
    $(".sticky-button").css("position", "fixed");
    $(".sticky-button").css("display", "flex");

    //Otherwise remove inline styles and thereby revert to original stying
  } else {
    $(".sticky-button").attr("style", "");
    $(".sticky-button").css("display", "none");
  }
});

function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    console.log(date);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/"; // affects all site pages
}
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

if (readCookie("silverbranch_age_check") === "true") {
} else {
  $("#sb-age-bg").show();
}
$(".close-age-popup").click(function () {
  createCookie("silverbranch_age_check", "true", 1);
  $(".silverbranch-age-bg").hide();
});

// Exit page Modal with Cookies
const modal = document.getElementById("onExitModal");

const span = document.getElementsByClassName("close")[0];

const exitEvent = (e) => {
  if (!e.toElement && !e.relatedTarget && e.clientY < 5) {
    document.removeEventListener("mouseout", exitEvent);
    modal.style.display = "block";

    setCookie("resumeModalSeen", true, 7);
  }
};

const setCookie = (cname, cvalue, exdays) => {
  let expires = "";

  if (exdays) {
    let day = new Date();
    day.setTime(day.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = `expires=${day.toUTCString()}`;
  }
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

const getCookie = (cname) => {
  let ca = document.cookie.split(";");

  for (const cookie of ca) {
    if (cookie.indexOf(cname + "=") > 0) {
      return cookie.split("=")[1];
    }
  }
  return null;
};

span.onclick = () => {
  modal.style.display = "none";
};
window.onclick = (e) => {
  if (e.target === modal) {
    modal.style.display = "none";
  }
};
if (!getCookie("resumeModalSeen")) {
  setTimeout(() => {
    document.addEventListener("mouseout", exitEvent);
  }, 6000);
}
